import React from 'react';
import { Link } from 'react-router-dom';

const KisiselVerilerinizinKorunmasi: React.FC = () => {
  return (
    <div className="page-content">
      <section style={{
        background: 'linear-gradient(135deg, #0066CC 0%, #003D82 100%)',
        color: '#fff',
        padding: '4rem 0',
        textAlign: 'center',
      }}>
        <div style={{ maxWidth: 1280, margin: '0 auto', padding: '0 1.5rem' }}>
          <h1 style={{
            fontSize: 'clamp(2rem, 4vw, 2.75rem)',
            fontWeight: 700,
            marginBottom: '0.75rem',
            letterSpacing: '-0.02em',
          }}>
            Kişisel Verilerinizin Korunması
          </h1>
          <p style={{ fontSize: '1.125rem', opacity: 0.9, lineHeight: 1.6 }}>
            Motopack olarak kişisel verilerinizin güvenliği bizim için önemlidir.
          </p>
        </div>
      </section>
      <section className="about-content" style={{ background: 'var(--bg-primary)', paddingTop: '2.5rem', paddingBottom: '2.5rem' }}>
        <div className="container">
          <h2 style={{ fontWeight: 700, fontSize: '1.3rem', color: 'var(--primary-color)', marginBottom: '1.2rem' }}>Kişisel Verilerin Korunması</h2>
          <div style={{ background: 'var(--primary-lightest)', borderRadius: '12px', padding: '1.1rem 1.2rem', marginBottom: '1.2rem', color: 'var(--primary-dark)', fontWeight: 600, fontSize: '1.05rem', boxShadow: '0 2px 8px 0 rgba(0,102,204,0.07)', textAlign: 'center' }}>
            Kişisel verileriniz, 6698 sayılı Kişisel Verilerin Korunması Kanunu kapsamında işlenmekte ve korunmaktadır. Detaylı bilgi için lütfen bizimle iletişime geçin.
          </div>
          <div style={{ color: 'var(--text-secondary)', fontSize: '1rem', marginBottom: '1.2rem', lineHeight: 1.7 }}>
            <h3 style={{ fontWeight: 600, color: 'var(--primary-color)', marginTop: '1.5rem', marginBottom: '0.5rem' }}>I. Giriş</h3>
            Motopack Lojistik ve Teknoloji A.Ş. (“Motopack” veya “Şirket”) olarak, kişisel verilerin korunması, 6698 sayılı Kişisel Verilerin Korunması Kanunu ("Kanun") ve ilgili mevzuatlar doğrultusunda önemli bir sorumluluktur. Bu Politika, kişisel verilerin işlenmesi ve korunmasına yönelik işbu yükümlülüklere nasıl uyduğumuzu açıklamayı amaçlamaktadır. Motopack, Kişisel Verileri Koruma Kurulu (“Kurul”) tarafından yayımlanan kararlar ve ikincil düzenlemelere tam uyum sağlamak amacıyla, kişisel verilerin hukuka uygun şekilde işlenmesi için gerekli tüm önlemleri alır ve ilgili kişileri bilgilendirir.
            <h3 style={{ fontWeight: 600, color: 'var(--primary-color)', marginTop: '1.5rem', marginBottom: '0.5rem' }}>II. Politikanın Kapsamı</h3>
            Bu Politika, Motopack tarafından işlenen tüm kişisel veriler için geçerli olup, şirketimizle herhangi bir ilişkisi bulunan müşteriler, tedarikçiler, iş ortakları, çalışan adayları ve diğer ilgili kişilerin verilerini kapsar. Çalışanlarımızın kişisel verilerinin korunmasına yönelik süreçler, ayrı bir Çalışan Kişisel Verilerinin Korunması ve İşlenmesi Politikası çerçevesinde değerlendirilmektedir.
            <h3 style={{ fontWeight: 600, color: 'var(--primary-color)', marginTop: '1.5rem', marginBottom: '0.5rem' }}>III. Tanımlar</h3>
            <b>Açık Rıza:</b> Belirli bir konuda, bilgilendirilerek ve özgür irade ile yapılan rıza açıklaması.<br />
            <b>Çalışan:</b> Şirket bünyesinde görevli çalışan, stajyer veya alt işveren çalışanı gerçek kişiler.<br />
            <b>Kişisel Veri:</b> Kimliği belirli veya belirlenebilir gerçek kişiye ilişkin her türlü bilgi.<br />
            <b>Özel Nitelikli Kişisel Veri:</b> Irk, etnik köken, siyasi düşünce, felsefi inanç, din, mezhep gibi hassas veriler.<br />
            <b>Veri Sorumlusu:</b> Kişisel verilerin işlenme amaçlarını ve araçlarını belirleyen gerçek veya tüzel kişi.<br />
            <b>Veri İşleyen:</b> Veri sorumlusunun verdiği yetkiye dayanarak, onun adına kişisel veri işleyen kişi.<br />
            <b>Kayıt Ortamı:</b> Verilerin saklandığı her türlü ortam (fiziksel ya da dijital).<br />
            Bu Politika’da yer almayan tanımlar için Kanun ve ilgili mevzuatta yer alan tanımlar geçerli olacaktır.
            <h3 style={{ fontWeight: 600, color: 'var(--primary-color)', marginTop: '1.5rem', marginBottom: '0.5rem' }}>IV. Kişisel Verilerin İşlenme İlkeleri</h3>
            Motopack, kişisel verilerin işlenmesinde Kanun’un 4. maddesinde belirtilen veri işleme ilkelerine uymayı taahhüt eder. Bu ilkeler şunlardır:<br />
            <b>Hukuka ve Dürüstlük Kurallarına Uygun Olma:</b> Veriler, yalnızca hukuka ve dürüstlük kurallarına uygun şekilde işlenir.<br />
            <b>Doğru ve Güncel Olma:</b> Verilerin doğru ve güncel olması sağlanır.<br />
            <b>Belirli, Açık ve Meşru Amaçlar İçin İşlenme:</b> Kişisel veriler yalnızca belirli ve açık amaçlarla işlenir.<br />
            <b>İşleme Amaçlarıyla Bağlantılı, Sınırlı ve Ölçülü Olma:</b> Veriler yalnızca amacına uygun şekilde işlenir.<br />
            <b>İlgili Mevzuat Gereği Süreyle Muhafaza Edilme:</b> Veriler yalnızca gerekli süreyle muhafaza edilir.
            <h3 style={{ fontWeight: 600, color: 'var(--primary-color)', marginTop: '1.5rem', marginBottom: '0.5rem' }}>V. Kişisel Verilerin İşlenme Şartları</h3>
            Motopack, kişisel verilerin işlenmesinde Kanun’un 5. maddesinde belirtilen şartlara dayanır. Kişisel veriler, aşağıdaki hallerde işlenebilir:<br />
            Kanunlarda açıkça öngörülmesi,<br />
            Sözleşmenin kurulması veya ifasıyla doğrudan ilgili olması,<br />
            Şirketin hukuki yükümlülüklerini yerine getirmesi,<br />
            İlgili kişinin açık rızası.<br />
            <b>Özel Nitelikli Kişisel Verilerin İşlenme Şartları</b><br />
            Özel nitelikli kişisel veriler, ilgili kişinin açık rızasına dayanarak işlenebilir veya Kanun’da öngörülen özel şartlarla işlenebilir.
            <h3 style={{ fontWeight: 600, color: 'var(--primary-color)', marginTop: '1.5rem', marginBottom: '0.5rem' }}>VI. Kişisel Verilerin Aktarılması</h3>
            Motopack, kişisel verileri, Kanun’a uygun şekilde üçüncü şahıslara aktarabilir. Kişisel veriler, aşağıdaki durumlar dışında, açık rıza alınmaksızın aktarılabilir:<br />
            Kanunlarda açıkça öngörülmesi,<br />
            Bir sözleşmenin kurulması veya ifasıyla doğrudan ilgili olması,<br />
            Hukuki yükümlülüklerin yerine getirilmesi.<br />
            <b>Yurt Dışına Kişisel Veri Aktarımı</b><br />
            Motopack, kişisel verilerin yurt dışına aktarılması gerektiğinde, Kurul tarafından belirlenen güvenlik önlemleri ve ek düzenlemelere uyarak aktarım işlemini gerçekleştirir.
            <h3 style={{ fontWeight: 600, color: 'var(--primary-color)', marginTop: '1.5rem', marginBottom: '0.5rem' }}>VII. Kişisel Veri Güvenliği</h3>
            Motopack, kişisel verilerin güvenliğini sağlamak amacıyla gerekli teknik ve idari tedbirleri alır. Bu tedbirler şunlardır:<br />
            Kişisel verilerin düzenli olarak yedeklenmesi,<br />
            Erişim kontrolü ile yalnızca yetkilendirilmiş kişilerin verilere erişebilmesi,<br />
            Özel nitelikli veriler için ekstra güvenlik önlemleri.<br />
            <b>A. Denetim</b><br />
            Şirket, kişisel veri güvenliğinin sağlanması ve hukuka aykırı işlenmesinin önlenmesi amacıyla düzenli denetimler yapar.<br />
            <b>B. Gizlilik</b><br />
            Tüm çalışanlar, kişisel verilerin gizliliğine saygı gösterme konusunda eğitilir ve kişisel verilerin gizliliği sağlanır.<br />
            <b>C. Kişisel Verilerin Yetkisiz İfşası</b><br />
            Kişisel verilerin yetkisiz kişiler tarafından elde edilmesi durumunda, durum en kısa sürede ilgili kişilere ve Kurul’a bildirilir.
            <h3 style={{ fontWeight: 600, color: 'var(--primary-color)', marginTop: '1.5rem', marginBottom: '0.5rem' }}>VIII. İlgili Kişilerin Hakları</h3>
            Kanun’un 11. maddesine göre, kişisel veri sahiplerinin aşağıdaki hakları vardır:<br />
            Kişisel verilerinin işlenip işlenmediğini öğrenme,<br />
            İşlenen verileri hakkında bilgi talep etme,<br />
            Verilerinin düzeltilmesini isteme,<br />
            Verilerinin silinmesini isteme,<br />
            Otomatik sistemlerle işlenen veriler üzerinden itiraz etme.<br />
            <b>Başvuru Yöntemleri:</b><br />
            Kişisel veri sahipleri, haklarını kullanmak için aşağıdaki iletişim yöntemlerini kullanabilirler:<br />
            E-posta: <a href="mailto:kvkk@motopack.com.tr" style={{ color: 'var(--primary-color)', textDecoration: 'underline' }}>kvkk@motopack.com.tr</a><br />
            Adres: Güzeloluk Mah. 1830 Sk. No:202/B Florya S. Muratpaşa / ANTALYA<br />
            Yasal haklarınızı kullanmak için belirtilen iletişim kanallarından biriyle başvurabilirsiniz. Talepler, en geç 30 gün içerisinde ücretsiz olarak cevaplanacaktır.
            <h3 style={{ fontWeight: 600, color: 'var(--primary-color)', marginTop: '1.5rem', marginBottom: '0.5rem' }}>IX. Politikanın Yürürlüğü ve Güncelleme</h3>
            Bu Politika, şirketin internet sitesinde yayımlandığı tarihten itibaren yürürlüğe girmiştir. Motopack, bu Politika’yı gerektiğinde güncelleme hakkına sahiptir ve yapılan değişiklikler yine internet sitesinde yayınlanacaktır.
          </div>
        </div>
      </section>
      {/* Yardım Kartı */}
      <section className="help-section" style={{ background: 'transparent', padding: 0, margin: 0 }}>
        <div className="container" style={{ maxWidth: 1200, margin: '0 auto', padding: '0 1.5rem' }}>
          <div style={{
            background: 'var(--primary-lightest)',
            borderRadius: '12px',
            padding: '1.1rem 1.2rem',
            margin: '2.2rem 0 1.2rem 0',
            color: 'var(--primary-dark)',
            fontWeight: 500,
            fontSize: '1.05rem',
            boxShadow: '0 2px 8px 0 rgba(0,102,204,0.07)',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            gap: '1.2rem',
            position: 'relative',
            minHeight: 110,
            flexWrap: 'wrap',
          }}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center' }}>
              <div style={{ fontWeight: 700, fontSize: '1.18rem', marginBottom: 6 }}>Herhangi Bir Yardım İhtiyacınız Var mı?</div>
              <div style={{ fontSize: '1.02rem', color: 'var(--primary-dark)', opacity: 0.92 }}>Merak ettiğiniz her konuda, şikayet ve önerilerinizle ilgili olarak bizimle iletişime geçebilirsiniz.</div>
            </div>
            <div style={{ marginLeft: 'auto', alignSelf: 'flex-end' }}>
              <Link to="/iletisim" style={{
                display: 'inline-block',
                background: 'linear-gradient(90deg, var(--primary-color) 0%, var(--primary-light) 100%)',
                color: '#fff',
                fontWeight: 700,
                fontSize: '1rem',
                borderRadius: 8,
                padding: '0.72rem 1.7rem',
                textDecoration: 'none',
                boxShadow: '0 2px 8px 0 rgba(0,102,204,0.09)',
                transition: 'background 0.18s, box-shadow 0.18s',
                position: 'relative',
                bottom: 0,
                right: 0,
                marginTop: 12,
              }}>Bize Yazın</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default KisiselVerilerinizinKorunmasi; 